/**
 * Recognition (Message Classification) API calls
 */

import apiClient from './client';
import {
  ClassifyRangeRequest,
  ClassificationResult,
} from '@/types/api';

/**
 * Classify messages in a range
 * Note: API returns ClassificationResult[] directly
 */
export const classifyMessageRange = async (
  request: ClassifyRangeRequest
): Promise<ClassificationResult[]> => {
  const response = await apiClient.post<ClassificationResult[]>(
    '/recognition/classify',
    request
  );
  return response.data;
};

/**
 * Get classification for a single message (if already classified)
 */
export const getMessageClassification = async (messageId: number): Promise<ClassificationResult> => {
  const response = await apiClient.get<ClassificationResult>(
    `/recognition/messages/${messageId}/classification`
  );
  return response.data;
};

/**
 * Batch classify specific messages
 */
export const classifyMessages = async (messageIds: number[]): Promise<ClassificationResult[]> => {
  const response = await apiClient.post<ClassificationResult[]>('/recognition/classify/batch', {
    message_ids: messageIds,
  });
  return response.data;
};
